/* =========================================================================
   Final-score medal tiers (pure, self-tested). Display-side — mirrors the
   prototype. Bank drives the tier; 90%+ accuracy with strong points earns gold
   even short of the bank bar. All money in cents.

   Display: `iconHtml` is the brand line icon for the results hero (trophy /
   medal / sprout inside a tinted .res-medal-ic ring) — the old emoji face is
   gone. gameController renders it with innerHTML.
   ========================================================================= */
import { icon, type IconName } from './ui/icons';

export type MedalTier = 'gold' | 'silver' | 'bronze' | 'wood';

export interface Medal {
  tier: MedalTier;
  /** Results-hero icon markup (brand SVG in a tier-tinted ring). */
  iconHtml: string;
  /** @deprecated Always ''. The results hero renders `iconHtml` instead; this
      field is kept only until gameController's textContent write is retired. */
  emoji: string;
  label: string;
  headline: string;
}

const TIER_ICON: Record<MedalTier, IconName> = { gold: 'trophy', silver: 'medal', bronze: 'medal', wood: 'sprout' };

/** `<span class="res-medal-ic gold">…svg…</span>` — PURE. */
export function medalIconHtml(tier: MedalTier, size = 56): string {
  return `<span class="res-medal-ic ${tier}" aria-hidden="true">${icon(TIER_ICON[tier], size)}</span>`;
}

export function medalFor(bankCents: number, accuracyPct: number): Medal {
  if (bankCents >= 3_000_000 || (accuracyPct >= 90 && bankCents >= 1_500_000))
    return { tier: 'gold', iconHtml: medalIconHtml('gold'), emoji: '', label: 'Holy Haul', headline: 'A Holy Haul. Well done.' };
  if (bankCents >= 2_100_000)
    return { tier: 'silver', iconHtml: medalIconHtml('silver'), emoji: '', label: 'Faithful Finish', headline: 'Well played, faithful one.' };
  if (bankCents >= 1_200_000)
    return { tier: 'bronze', iconHtml: medalIconHtml('bronze'), emoji: '', label: 'Growing in Grace', headline: 'A good and faithful effort.' };
  return { tier: 'wood', iconHtml: medalIconHtml('wood'), emoji: '', label: 'Humble Pilgrim', headline: 'Every saint started somewhere.' };
}
